import { log, setLogUrl } from "@hoylu/client-common";
import { ajax } from "rxjs/ajax";
import { flagsForUserObservable } from "../feature-flags-dispatch";
import {
  sendMessageToAllWorkspaces,
  sendMessageToWorkspace,
} from "../post-message-dispatch";
import { openWorkspaceInNewWindow } from "../utils/openWorkspaceInNewWindow";
import { getNexusReportService, getNexusTaskService } from "./analytics";
import {
  headRequest,
  postJSON,
  putJSON,
  requestBlob,
  requestText,
} from "./dependencies/ajaxRequests";
import { hubspotTryTrackUserRegistration } from "./dependencies/hubspot";
import {
  getTokenSilent,
  handleLogin,
  handleLogout,
  registerEmail,
} from "./dependencies/loginDependencies";
import { syncHistory } from "./dependencies/manageBrowserHistory";
import {
  removeThumbnail,
  uploadThumbnail,
} from "./dependencies/uploadServiceDependencies";
import { clearWebexShareUrl, setWebexShareUrl } from "./dependencies/webex";
import {
  focusWorkspace,
  getDocumentTitle,
  updateDocumentTitle,
} from "./dependencies/workspaceDependencies";
import { templateRequests } from "./templates/template.requests";
import { documentIdv3Requests } from "./workspaces/api/documentId.requests";

export default {
  clearWebexShareUrl,
  deleteAjax: ajax.delete,
  documentIdv3Requests,
  flagsForUser: flagsForUserObservable,
  focusWorkspace,
  getDocumentTitle,
  getJSON: ajax.getJSON,
  getNexusReportService,
  getNexusTaskService,
  getTokenSilent,
  headRequest,
  hubspotTryTrackUserRegistration,
  log,
  login: handleLogin,
  logout: handleLogout,
  openWorkspaceInNewWindow,
  postJSON,
  putJSON,
  registerEmail,
  removeThumbnail,
  requestBlob,
  requestText,
  sendMessageToAllWorkspaces,
  sendMessageToWorkspace,
  setLogUrl,
  setWebexShareUrl,
  syncHistory,
  templateRequests,
  updateDocumentTitle,
  uploadThumbnail,
};
